import { useCallback, useEffect, useRef } from 'react'
import { ListOption } from '../organisms/list/list-option/list-option.type'

const KEY_INPUT_WAITING_PERIOD = 700

export const useSearchString = (options: ListOption[]) => {
  const searchString = useRef<string>('')
  const searchTimeout = useRef<number | null>(null)

  const getSearchString = useCallback((char: string) => {
    if (typeof searchTimeout.current === 'number') {
      window.clearTimeout(searchTimeout.current)
    }

    searchTimeout.current = window.setTimeout(() => {
      searchString.current = ''
    }, KEY_INPUT_WAITING_PERIOD)

    // add most recent letter to saved search string
    searchString.current += char
    return searchString.current
  }, [])

  const getSearchResult = useCallback(
    (keyValue: string) => {
      const searchString = getSearchString(keyValue)
      // using the text field in the ListOption to search since it is displayed text
      const matchingOptionIndex = options.findIndex(
        (option: ListOption) => option.text && option.text.toLowerCase().startsWith(searchString.toLowerCase())
      )
      const isMatchFound = matchingOptionIndex >= 0
      const matchedStringIndex = isMatchFound ? matchingOptionIndex : 0

      return { isMatchFound, matchedStringIndex }
    },
    [getSearchString, options]
  )

  useEffect(() => {
    return () => {
      if (typeof searchTimeout.current === 'number') {
        window.clearTimeout(searchTimeout.current)
      }
    }
  }, [])

  return { getSearchResult }
}
